import type { BranchKey } from '@festina-life/api'
import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { Popover, PopoverButton } from '@festina-life/ui/structure'

import { ActionsMenuPanel } from '../../../actionsPanel/ActionsMenuPanel'
import { UpgradeBranchForm } from './UpgradeBranchForm'

type Props = {
  branchKey: BranchKey
}

export const UpgradeBranchButton = ({ branchKey }: Props) => {
  const translate = useTranslate()
  return (
    <Popover>
      <PopoverButton as="div">
        <Button startIcon="ArrowTrendingUp">
          {translate('branchDetailsPanel.tabs.manage.upgrade')}
        </Button>
      </PopoverButton>
      <ActionsMenuPanel anchor={{ to: 'right' }} className="max-w-lg!">
        <UpgradeBranchForm branchKey={branchKey} />
      </ActionsMenuPanel>
    </Popover>
  )
}
